module.exports = __webpack_public_path__ + "img/blog-6.466a9e6f.webp";